module.exports = __webpack_public_path__ + "public-ui/img/b2.57e1c558.svg";